import React, { useEffect } from 'react'
import './Cashews.css'
import Breadcrumb from '../../../../../components/Breadcrum';
import InfoContainer from '../../../../../components/InfoContainer';

const cahsewData = [
  {
    imgSrc: "./assets/img/agriculturalCommodities/White-Wholes.jpg",
    text: "White Wholes",
    // certificateSrc: "./assets/img/certificates/pharmexcell-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/Scorched-Wholes.jpg",
    text: "Scorched Wholes",
    // certificateSrc: "./assets/img/certificates/apeda-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/Large-White-Pieces.jpg",
    text: "Large White Pieces",
    certificateSrc: "./assets/img/certificates/gst-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/Small-White-Pieces.jpg",
    text: "Small White Pieces",
    // certificateSrc: "./assets/img/certificates/udyam-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/Baby-Bits.jpg",
    text: "Baby Bits",
    // certificateSrc: "./assets/img/certificates/fssai-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/Butts.jpg",
    text: "Butts",
    // certificateSrc: "./assets/img/certificates/chemexill-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/Scorched-Pieces-Seconds.jpg",
    text: "Scorched Pieces Seconds",
    // certificateSrc: "./assets/img/certificates/onestar-certificate.jpg",
  },
  {
    imgSrc: "./assets/img/agriculturalCommodities/Splits.jpg",
    text: "Splits",
    // certificateSrc: "./assets/img/certificates/spices-board-certificate.jpg",
  },
];
export default function Cashews() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title="Cashews"
        backgroundImage='./assets/img/contact-banner.png'
        height="40vh"
      ></Breadcrumb>

      <div className="container pt-5">
        <div className="cashew-grades">
          <h4 className="mb-15px">Cashew Grades</h4>
          <p>
            Cashew Kernels are graded into <b>white / scorched</b> wholes, splits, butts, etc. Depending on the shape, size, and colour of the kernel.
            There are various different grades of cashew kernels, but few grades are commercially available and traded. They are:
          </p>
          <ul className="listdisplay circle">
            <li className="grey"><b>W – 180</b>, is the 'King of Cashew' - They are larger in size and very expensive.</li>
            <li className="grey"><b>W – 210</b>, are popularly known as 'Jumbo' nuts.</li>
            <li className="grey"><b>W - 240</b>, it is an attractive grade which is reasonably priced.</li>
            <li className="grey"><b>W – 320</b>, are the most popular among cashew kernels and highest in terms of availability, worldwide.</li>
            <li className="grey"><b>W – 450</b>, are the smallest and cheapest white whole kernels and hence the favorite among low-priced whole grades.</li>
          </ul>
          <p></p>
          <p>
            Scorched wholes are another grade of cashew kernels, which have a slight brown colour due to longer roasting. They have all the other characteristics of white kernels and have the same nutritional qualities.
          </p>
          <p>
            Butts, splits, and pieces are priced lower and are ideal for cooking, preparation of sweets, and savory snacks.
          </p>

          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Grades</th>
                  <th>Types</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>White Wholes(WW)</td>
                  <td>
                    <a href="#white_wholes" className="link-style">WW-180</a>,
                    <a href="#white_wholes" className="link-style">WW-210</a>,
                    <a href="#white_wholes" className="link-style">WW-240</a>,
                    <a href="#white_wholes" className="link-style">WW-320</a>,
                    <a href="#white_wholes" className="link-style">WW-450</a>,
                    <a href="#white_wholes" className="link-style">WW-500</a>,
                    <br />
                    <a href="#white_pieces" className="link-style">Large White Pieces(LWP)</a>,
                    <a href="#white_pieces" className="link-style">Small White Pieces(SWP)</a>,
                    <br />
                    <a href="#white_pieces" className="link-style">Butts</a>,
                    <a href="#white_pieces" className="link-style">Splits</a>
                  </td>
                </tr>
                <tr>
                  <td>Scorched Wholes(SW)</td>
                  <td>
                    <a href="#scorched_wholes" className="link-style">SW</a>,
                    <a href="#scorched_wholes" className="link-style">SW-180</a>,
                    <a href="#scorched_wholes" className="link-style">SW-210</a>,
                    <a href="#scorched_wholes" className="link-style">SW-240</a>,
                    <a href="#scorched_wholes" className="link-style">SW-320</a>,
                    <a href="#scorched_wholes" className="link-style">SW-450</a>,
                    <a href="#scorched_wholes" className="link-style">SW-500</a>,
                    <br />
                    <a href="#scorched_pieces" className="link-style">Scorched Splits(SS)</a>,
                    <a href="#scorched_pieces" className="link-style">Scorched Pieces(SP)</a>,
                    <br />
                    <a href="#scorched_pieces" className="link-style">Large Scorched Pieces(LSP)</a>,
                    <a href="#scorched_pieces" className="link-style">Scorched Small Pieces(SSP)</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-12 text-center mx-auto">
              {/* <h2 className="mb-5">Credentials</h2> */}
              {/* <h2 className="mb-5">Our Accreditations</h2> */}
            </div>

            {cahsewData.map((cashew, index) => (
              <div
                key={index}
                className="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0"
                style={{
                  cursor: cashew.certificateSrc ? "pointer" : "default",
                }}
              >
                <div className="featured-block d-flex justify-content-center align-items-center">
                  <div className="d-block">
                    <img
                      src={cashew.imgSrc}
                      className="featured-block-image img-fluid"
                      alt={cashew.text}
                    />
                    <p
                      className={`featured-block-text ${
                        ["FSSAI", "Chemexcil"].includes(cashew.text)
                          ? "extra-padding"
                          : ""
                      }`}
                    >
                      <strong>{cashew.text}</strong>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
        </div>
      </div>
      <div className="container py-5">
        <div className="common-packing">
          <h4 className="mb-15px">Common Packing For Container Shipment</h4>
          <p>
            Nuragro packs the cashew in the following options, these are now the most preferred packing by most of our buyers.
          </p>
          <ul className="listdisplay circle">
            <li className="grey">Two flexi packs of 25lbs each in a carton for a total of 50lbs.</li>
            <li className="grey">700-750 such cartons make a full container load.</li>
          </ul>
          <p></p>
          <p>
            The other mode of packing Nuragro does is Two 'KO' type tins of 25lbs each in a carton for a total of 50 lbs. 700 such cartons make a full container load.
          </p>
          <p>
            For the Middle East, Nuragro also packs in 10Kg tins, in which case two such tins are packed in a carton for a total of 20Kgs. 750 such cartons make a full container load. Full container load is preferred as it results in huge savings in ocean freight.
          </p>

          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Packing</th>
                  <th>In 20' Full Load Containers</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>In 2 x 10 kgs vacuumized tins in cartons</td>
                  <td>700 cartons</td>
                </tr>
                <tr>
                  <td>In 2 x 25 lbs (11.34 kgs) vacuumized tins in cartons</td>
                  <td>700 cartons</td>
                </tr>
                <tr>
                  <td>In 1 x 50 lbs (22.68 kgs) vacuum flexi pouches in cartons</td>
                  <td>700 cartons</td>
                </tr>
                <tr>
                  <td>In 2 x 25 lbs (11.34 kgs) vacuum flexi pouches in cartons</td>
                  <td>700 cartons</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
            <div className="container">
      <div className="row ">
        <div className="white_box">
          <section id="specification">
            <h4 className="mb-15px">Specification of Cashew Kernels</h4>

            {/* White Wholes Table */}
            <div id="white_wholes" className="table-responsive">
              <table className="table table-bordered">
                <caption className="text-center">Cashew Kernels - White Wholes</caption>
                <thead>
                  <tr>
                    <th>Grades&nbsp;&nbsp;&nbsp;&nbsp;</th>
                    <th>Color/ Characteristics</th>
                    <th>Count/454gms Size Description</th>
                    <th>Max. Moisture%</th>
                    <th>Max. Broken%</th>
                    <th>NLSG<br /> NLG Max%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>WW-180</td>
                    <td rowspan="6">White / pale ivory / light ash.<br />Characteristic shape</td>
                    <td>170-180</td>
                    <td>5</td>
                    <td>5</td>
                    <td rowspan="5">5(NLSG &amp; SW together)</td>
                  </tr>
                  <tr>
                    <td>WW-210</td>
                    <td>200-210</td>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>WW-240</td>
                    <td>220-240</td>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>WW-320</td>
                    <td>300-320</td>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>WW-450</td>
                    <td>400-450</td>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>WW-500</td>
                    <td>450-500</td>
                    <td>5</td>
                    <td>5</td>
                    <td>5(SW)</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="6" className="text-left">
                      <p className="small">
                        Remarks: Kernels shall be completely free from infestation, insect damage, mould rancidity, adhering
                        testa and objectionable extraneous matter. Scraped and partially shrivelled kernels also permitted
                        provided such scraping/shrivelling does not affect the characteristic shape of the kernel.
                      </p>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Scorched Wholes Table */}
            <div id="scorched_wholes" className="table-responsive">
              <table className="table table-bordered">
                <caption className="text-center">Cashew Kernels - Scorched Wholes</caption>
                <thead>
                  <tr>
                    <th>Grades&nbsp;&nbsp;&nbsp;&nbsp;</th>
                    <th>Color/ Characteristics</th>
                    <th>Count/454gms Size Description</th>
                    <th>Max. Moisture%</th>
                    <th>Max. Broken%</th>
                    <th>NLSG<br /> NLG Max%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>SW</td>
                    <td rowspan="7">Kernels may be scorched /<br />slightly darkened due to over-heating while roasting <br />or drying in drier/borma</td>
                    <td>N.A</td>
                    <td>5</td>
                    <td>5</td>
                    <td>7.5 (SSW)</td>
                  </tr>
                  <tr>
                    <td>SW-180</td>
                    <td>170-180</td>
                    <td>5</td>
                    <td>5</td>
                    <td rowspan="5">7.5 (NLSG &amp; SSW together)</td>
                  </tr>
                  <tr>
                    <td>SW-210</td>
                    <td>220-240</td>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>SW-240</td>
                    <td>220-240</td>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>SW-320</td>
                    <td>300-320</td>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>SW-450</td>
                    <td>400-450</td>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>SW-500</td>
                    <td>450-500</td>
                    <td>5</td>
                    <td>5</td>
                    <td>7.5(SSW)</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="6" className="text-left">
                      <p className="small">
                        Remarks: Kernels shall be completely free from infestation, insect damage, mould rancidity, adhering
                        testa and objectionable extraneous matter. Scraped and partially shrivelled kernels also permitted
                        provided such scraping/shrivelling does not affect the characteristic shape of the kernel.
                      </p>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Desert Wholes Table */}
            <div id="desert_wholes" className="table-responsive">
              <table className="table table-bordered">
                <caption className='text-center'>Cashew Kernels - Desert Wholes</caption>
                <thead>
                  <tr>
                    <th>Grades&nbsp;&nbsp;&nbsp;&nbsp;</th>
                    <th>Trade Name</th>
                    <th>Color/ Characteristics</th>
                    <th>Count/454gms Size Description</th>
                    <th>Max. Moisture%</th>
                    <th>Max. Broken%</th>
                    <th>NLSG<br /> NLG Max%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>SSW</td>
                    <td>Scorched Wholes Seconds</td>
                    <td>Kernels may be overscorched, immature, shriveled (Pirival), speckled (Karaniram) discoloured and light blue</td>
                    <td>N.A</td>
                    <td>5</td>
                    <td>5</td>
                    <td>7.5 (DW)</td>
                  </tr>
                  <tr>
                    <td>DW</td>
                    <td>Dessert Wholes</td>
                    <td>Kernels may be deep scorched, deep brown, deep blue, speckled, discoloured and black spotted</td>
                    <td>N.A</td>
                    <td>5</td>
                    <td>5</td>
                    <td>-</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="7" className="text-left">
                      <p className="small">
                        Remarks: Kernels shall be completely free from infestation, insect damage, mould rancidity, adhering
                        testa and objectionable extraneous matter.
                      </p>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div id="white_pieces" className="table-responsive">
              <table className="table table-bordered">
                <caption className='text-center'>Cashew Kernels - White Pieces</caption>
                <thead>
                  <tr>
                    <th>Grades&nbsp;&nbsp;&nbsp;&nbsp;</th>
                    <th>Trade Name</th>
                    <th>Color/ Characteristics</th>
                    <th>Count/454gms Size Description</th>
                    <th>Max. Moisture%</th>
                    <th>Max. Broken%</th>
                    <th>NLSG<br /> NLG Max%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>B</td>
                    <td>Butts</td>
                    <td>White/pale ivory or light ash. Kernels broken cross-wise (evenly or unevenly) naturally attached</td>
                    <td>N.A</td>
                    <td>5</td>
                    <td>5</td>
                    <td>5(SB)</td>
                  </tr>
                  <tr>
                    <td>S</td>
                    <td>Splits</td>
                    <td>White/pale ivory or light ash. Kernels split naturally lengthwise</td>
                    <td>N.A</td>
                    <td>5</td>
                    <td>5</td>
                    <td>&lt;5(SS)</td>
                  </tr>
                  <tr>
                    <td>LWP</td>
                    <td>Large White Pieces</td>
                    <td>White/pale ivory or light ash</td>
                    <td>Kernels broken into more than two pieces and not passing through 4 mesh 16 SWG sieve/4.75mm I.S. Sieve</td>
                    <td>5</td>
                    <td>Nil</td>
                    <td>5(SW &amp; SP together)</td>
                  </tr>
                  <tr>
                    <td>SWP</td>
                    <td>Small White Pieces</td>
                    <td>White/pale ivory or light ash</td>
                    <td>Broken kernels smaller than those described on LWP but not passing through 6 mesh 20 SWG Sieve/2.80 mm I.S. Sieve</td>
                    <td>5</td>
                    <td>Nil</td>
                    <td>5 (BB &amp; SSP together)</td>
                  </tr>
                  <tr>
                    <td>BB</td>
                    <td>Baby Bits</td>
                    <td>Do</td>
                    <td>Plemules and broken kernels smaller than those described as SWP but not passing through a 10 mesh 24SWG Sieve/1.70mm I.S. Sieve</td>
                    <td>5</td>
                    <td>Nil</td>
                    <td>1% (cashew powder)</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="7" className="text-left">
                      <p className="small">
                        Remarks: Kernels shall be completely free from infestation, insect damage, mould rancidity, adhering
                        testa and objectionable extraneous matter. Scraped and partially shriveled kernels are also permitted
                        provided such scraping/shriveling does not affect the characteristic shape of the kernel.
                      </p>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div id="scorched_pieces" className="table-responsive">
              <table className="table table-bordered">
                <caption className='text-center'>Cashew Kernels - Scorched Pieces</caption>
                <thead>
                  <tr>
                    <th>Grades&nbsp;&nbsp;&nbsp;&nbsp;</th>
                    <th>Trade Name</th>
                    <th>Color/ Characteristics</th>
                    <th>Count/454gms Size Description</th>
                    <th>Max. Moisture%</th>
                    <th>Max. Broken%</th>
                    <th>NLSG<br /> NLG Max%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>SB</td>
                    <td>Scorched Butts</td>
                    <td>
                      Kernels broken crosswise (evenly or unevenly) and naturally attached. Kernels may be scorched/slightly
                      darkened due to over heating while roasting or drying in the drier/borma
                    </td>
                    <td>N.A</td>
                    <td>5</td>
                    <td>5</td>
                    <td>7.5(DB)</td>
                  </tr>
                  <tr>
                    <td>SS</td>
                    <td>Scorched Splits</td>
                    <td>
                      Kernels split naturally lengthwise. Kernels may be scorched/slightly darkened due to overheating while
                      roasting or drying in drier/borma
                    </td>
                    <td>N.A</td>
                    <td>5</td>
                    <td>5</td>
                    <td>7.5(DS)</td>
                  </tr>
                  <tr>
                    <td>SP</td>
                    <td>Scorched Pieces</td>
                    <td>
                      Kernels may be scorched/slightly darkened due to overheating while roasting or drying in drier/borma
                    </td>
                    <td>Pieces passing through a mesh 16 SWG sieve/4.75 mm I.S. Sieve</td>
                    <td>5</td>
                    <td>Nil</td>
                    <td>7.5 (SSP &amp; SPS together)</td>
                  </tr>
                  <tr>
                    <td>SSP</td>
                    <td>Scorched Small Pieces</td>
                    <td>
                      Kernels may be scorched/slightly darkened due to overheating while roasting or drying in drier/borma
                    </td>
                    <td>Pieces smaller than SP but not passing through a 6 mesh 20 SWG Sieve/2.80 mm I.S. Sieve</td>
                    <td>5</td>
                    <td>Nil</td>
                    <td>5 (DSP)</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="7" className="text-left">
                      <p className="small">
                        Remarks: Kernels shall be completely free from infestation, insect damage, mould rancidity, adhering
                        testa and objectionable extraneous matter. Scraped and partially shriveled kernels are also permitted
                        provided such scraping/shriveling does not affect the characteristic shape of the kernel.
                      </p>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div id="dessert_pieces" className="table-responsive">
              <table className="table table-bordered">
                <caption className='text-center'>Cashew Kernels - Dessert Pieces</caption>
                <thead>
                  <tr>
                    <th>Grades&nbsp;&nbsp;&nbsp;&nbsp;</th>
                    <th>Trade Name</th>
                    <th>Color/ Characteristics</th>
                    <th>Count/454gms Size Description</th>
                    <th>Max. Moisture%</th>
                    <th>Max. Broken%</th>
                    <th>NLSG<br /> NLG Max%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>SPS</td>
                    <td>Scorched Pieces Seconds</td>
                    <td>
                      Kernels may be overscorched, immature, shriveled (Pirival), speckled (Karaniram), discolored, and light blue.
                    </td>
                    <td>Kernels broken into pieces but not passing through a 4 mesh 16 SWG sieve/4.75 mm I.S. Sieve</td>
                    <td>5</td>
                    <td>Nil</td>
                    <td>7.5 (DP &amp; DSP together)</td>
                  </tr>
                  <tr>
                    <td>DP</td>
                    <td>Dessert Pieces</td>
                    <td>
                      Kernels may be deep scorched, deep brown, blue, speckled, discolored, and black spotted.
                    </td>
                    <td>Kernels broken into pieces but not passing through a 4 mesh 16 SWG sieve/4.75 mm and I.S. Sieve</td>
                    <td>5</td>
                    <td>Nil</td>
                    <td>7.5 (DSP)</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="7" className="text-left">
                      <p className="small">
                        Remarks: Kernels shall be completely free from infestation, insect damage, mould rancidity, adhering testa, and objectionable extraneous matter.
                      </p>
                      <p className="small">
                        NLSG denotes: Next Lower Size Grade. NLG denotes: Next Lower Grade.
                      </p>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div className="wrapper">
                  <img src="./assets/img/agriculturalCommodities/cashew_facts.jpg" alt="Cashew Nuts Facts" />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <section id="nutrition_fact">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="wrapper">
                      <h4>Nutrition Facts</h4>
                      <ul>
                        <li className="top">Serving Size: 100gm</li>
                        <li className="border_top_thick"></li>
                        <li className="small"><b>Amounts per servings</b></li>
                        <li>
                          <div className="byonethird left"><b>Calories</b> 553</div>
                          <div className="bytwothird right textleft">Calories from Fat 367</div>
                        </li>
                        <li className="border_top_thin"></li>
                        <li className="small textleft"><b>% Daily Values*</b></li>
                        <li>
                          <div className="desc"><b>Total Fat</b> 44 g</div>
                          <div className="percent"><b>67</b>%</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Saturated fat 8 g</div>
                          <div className="percent"><b>40</b>%</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Polyunsaturated fat 8 g</div>
                          <div className="percent">&nbsp;</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Monounsaturated fat 24 g</div>
                          <div className="percent">&nbsp;</div>
                        </li>
                        <li>
                          <div className="desc"><b>Cholesterol</b> 0 mg</div>
                          <div className="percent"><b>0</b>%</div>
                        </li>
                        <li>
                          <div className="desc"><b>Sodium</b> 12 mg</div>
                          <div className="percent"><b>0</b>%</div>
                        </li>
                        <li>
                          <div className="desc"><b>Potassium</b> 660 mg</div>
                          <div className="percent"><b>18</b>%</div>
                        </li>
                        <li>
                          <div className="desc"><b>Total Carbohydrate</b> 30 g</div>
                          <div className="percent"><b>10</b>%</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Dietary fiber 3.3 g</div>
                          <div className="percent"><b>13</b>%</div>
                        </li>
                        <li className="sub">
                          <div className="desc">Sugar 6 g</div>
                          <div className="percent">&nbsp;</div>
                        </li>
                        <li>
                          <div className="desc"><b>Protein</b> 18 g</div>
                          <div className="percent"><b>36</b>%</div>
                        </li>
                        <li className="border_top_thick"></li>
                        <li>
                          <div className="bytwo left">
                            <div className="desc">Vitamin A</div>
                            <div className="percent"><b>0</b>%</div>
                          </div>
                          <div className="bytwo right">
                            <div className="desc">Vitamin C</div>
                            <div className="percent"><b>0</b>%</div>
                          </div>
                        </li>
                        <li>
                          <div className="bytwo left">
                            <div className="desc">Calcium</div>
                            <div className="percent"><b>3</b>%</div>
                          </div>
                          <div className="bytwo right">
                            <div className="desc">Iron</div>
                            <div className="percent"><b>37</b>%</div>
                          </div>
                        </li>
                        <li>
                          <div className="bytwo left">
                            <div className="desc">Vitamin D</div>
                            <div className="percent"><b>0</b>%</div>
                          </div>
                          <div className="bytwo right">
                            <div className="desc">Vitamin B-6</div>
                            <div className="percent"><b>20</b>%</div>
                          </div>
                        </li>
                        <li>
                          <div className="bytwo left">
                            <div className="desc">Vitamin B-12</div>
                            <div className="percent"><b>0</b>%</div>
                          </div>
                          <div className="bytwo right">
                            <div className="desc">Magnesium</div>
                            <div className="percent"><b>73</b>%</div>
                          </div>
                        </li>
                        <li className="small">*Percent Daily Values are based on a 2,000 Calorie diet.</li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>
      </div>
      </div>

      <div className="greenbox container my-5">
        <div className="theme_facts">
          <h1>Facts on Peanut Nuts</h1>
          <p className="white">
            The peanut, also known as the groundnut and the goober and taxonomically classified as Arachis hypogaea, is a legume crop grown mainly for its edible seeds. It is widely grown in the tropics and subtropics, being important to both small and large commercial producers. It is classified as both a grain legume and, because of its high oil content, an oil crop. World annual production of shelled peanuts was 42 million tonnes in 2014. Atypically among crop plants, peanut pods develop underground rather than aboveground. It is this characteristic that the botanist Linnaeus used to assign the specific name hypogaea, which means "under the earth."
          </p>
          <p className="white">
            As a legume, the peanut belongs to the botanical family Fabaceae; this is also known as Leguminosae, and commonly known as the bean, or pea, family. Like most other legumes, peanuts harbor symbiotic nitrogen-fixing bacteria in root nodules. This capacity to fix nitrogen means peanuts require less nitrogen-containing fertilizer and improve soil fertility, making them valuable in crop rotations.
          </p>
          <p className="white">
            Peanuts are similar in taste and nutritional profile to tree nuts such as walnuts and almonds, and are often served in similar ways in Western cuisines. The botanical definition of a "nut" is a fruit whose ovary wall becomes very hard at maturity. Using this criterion, the peanut is not a true nut, but rather a legume. However, for culinary purposes and in common English language usage, peanuts are usually referred to as nuts.
          </p>
        </div>
      </div>
    </>
  );
}